// src/routes/AppRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/home/HomePage';
import NewCompanyPage from '../pages/company/NewCompanyPage';
import CompanyPage from '../pages/company/CompanyPage';
import ClientPage from '../pages/client/clientPage';
import ProtectedRoute from './protectedRoute';
import PricingFlow from '../pages/pricing/PricingFlow';
import PricingListPage from '../pages/pricing/PricingListPage';

const ROUTE_PERMISSIONS = {
  dashboard: [], // qualquer usuário logado pode acessar
  cashFlow: ['cashFlow.screen'],
  company: ['company.screen'],
  users: ['users.screen'],
  projects: ['projects.screen'],
  services: ['services.screen'],
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/* <Route
        path="/dashboard"
        element={<ProtectedRoute component={DashboardPage} requiredPermissions={ROUTE_PERMISSIONS.dashboard} />}
      /> */}
      {/* <Route
        path="/cashflow"
        element={<ProtectedRoute component={CashFlowPage} requiredPermissions={ROUTE_PERMISSIONS.cashFlow} />}
      /> */}
      <Route
        path="/new-company"
        element={<ProtectedRoute component={NewCompanyPage} requiredPermissions={ROUTE_PERMISSIONS.dashboard} />}
      />
      <Route
        path="/company"
        element={<ProtectedRoute component={CompanyPage} requiredPermissions={ROUTE_PERMISSIONS.company} />}
      />
      {/* <Route
        path="/users"
        element={<ProtectedRoute component={UsersPage} requiredPermissions={ROUTE_PERMISSIONS.users} />}
      /> */}
      {/* <Route
        path="/projects"
        element={<ProtectedRoute component={ProjectsPage} requiredPermissions={ROUTE_PERMISSIONS.projects} />}
      /> */}
      {/* <Route
        path="/services"
        element={<ProtectedRoute component={ServicePage} requiredPermissions={ROUTE_PERMISSIONS.services} />}
      /> */}
      <Route
        path="/client"
        element={<ProtectedRoute component={ClientPage} requiredPermissions={ROUTE_PERMISSIONS.services} />}
      />
      <Route
        path="/pricing"
        element={<ProtectedRoute component={PricingListPage} requiredPermissions={ROUTE_PERMISSIONS.services} />}
      />
      <Route
        path="/pricing/new"
        element={<ProtectedRoute component={PricingFlow} requiredPermissions={ROUTE_PERMISSIONS.services} />}
      />
      <Route
        path="/pricing/:id/edit"
        element={<ProtectedRoute component={PricingFlow} requiredPermissions={ROUTE_PERMISSIONS.services} />}
      />
      <Route
        path="/pricing/:id/resume"
        element={<ProtectedRoute component={PricingFlow} requiredPermissions={ROUTE_PERMISSIONS.services} />}
      />
      {/* Página para acesso negado */}
      <Route
        path="/access-denied"
        element={
          <div style={{ padding: '4rem', textAlign: 'center' }}>
            <h1>403 - Acesso Negado</h1>
            <p>Você não possui permissão para acessar esta página.</p>
          </div>
        }
      />
    </Routes>
  );
};

export default AppRoutes;